import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { siteInfo, testimonials } from '@/mocks/manhua';

export default function AboutPage() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫网是什么？',
        acceptedAnswer: { '@type': 'Answer', text: '韩漫网是一个专注于韩漫在线阅读的平台，提供免费的下拉式漫画阅读体验，无需下载即可畅读各类韩漫资源。' },
      },
      {
        '@type': 'Question',
        name: '韩漫网的漫画资源有哪些类型？',
        acceptedAnswer: { '@type': 'Answer', text: '韩漫网涵盖爱情、奇幻、动作、悬疑、搞笑、剧情等六大分类，收录了大量热门韩漫作品，每日更新最新内容。' },
      },
      {
        '@type': 'Question',
        name: '如何在韩漫网阅读漫画？',
        acceptedAnswer: { '@type': 'Answer', text: '在韩漫网上，您可以直接通过浏览器访问网站，选择喜欢的漫画分类或搜索作品名称，点击即可在线阅读，采用下拉式阅读方式，无需翻页。' },
      },
      {
        '@type': 'Question',
        name: '韩漫网需要注册或付费吗？',
        acceptedAnswer: { '@type': 'Answer', text: '韩漫网提供完全免费的漫画阅读服务，您无需注册账号或支付任何费用，即可畅读全站所有漫画内容。' },
      },
      {
        '@type': 'Question',
        name: '韩漫网的漫画多久更新一次？',
        acceptedAnswer: { '@type': 'Answer', text: '韩漫网每日更新大量漫画资源，热门连载作品通常每周更新，确保读者能够第一时间阅读到最新章节内容。' },
      },
    ],
  };

  const fullSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: 'http://youplz.com/',
        description: siteInfo.description,
        email: siteInfo.email,
        telephone: siteInfo.phone,
        address: {
          '@type': 'PostalAddress',
          streetAddress: siteInfo.address,
        },
        sameAs: ['http://youplz.com/'],
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://youplz.com/' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://youplz.com/about' },
        ],
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 韩漫网',
        description: '了解韩漫网——免费观看下拉式韩漫的最佳平台。品牌介绍、信誉保障与联系方式。',
        url: 'http://youplz.com/about',
      },
      faqSchema,
    ],
  };

  const features = [
    {
      icon: 'ri-stack-line',
      title: '海量资源',
      description: '汇集数千部韩漫作品，覆盖六大热门分类，满足不同读者的喜好与需求。',
    },
    {
      icon: 'ri-file-list-2-line',
      title: '下拉式体验',
      description: '采用独特的下拉式阅读方式，无需点击翻页，滚动即可流畅阅读整个章节。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      description: '网站内容每日更新，热门连载作品第一时间同步，绝不错过任何精彩剧情。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无广告',
      description: '纯净的阅读环境，无弹窗广告骚扰，让您沉浸在漫画世界中不受打扰。',
    },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(fullSchema) }}
      />
      <Navbar />
      <main>
        <section className="bg-background-100 pt-24 pb-14 md:pb-20">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="max-w-3xl">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                品牌介绍
              </span>
              <h1 className="mt-4 text-2xl md:text-5xl font-bold text-foreground-950 font-heading leading-tight">
                关于韩漫网
                <br />
                您的韩漫阅读伙伴
              </h1>
              <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
                {siteInfo.description}
              </p>
              <div className="flex flex-wrap gap-3 mt-8">
                <a href="#features" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap">
                  平台特色
                  <i className="ri-arrow-down-line text-xs"></i>
                </a>
                <a href="#contact" className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20" id="features">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 border border-foreground-300 text-foreground-700 text-xs font-medium rounded-full whitespace-nowrap">
                我们的优势
              </span>
              <h2 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-950 font-heading leading-tight">
                为什么选择韩漫网
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                四大核心优势，为您打造最佳的韩漫阅读体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
              {features.map((feat) => (
                <div
                  key={feat.title}
                  className="bg-background-50 border border-background-200 rounded-lg p-6 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-background-50/20 transition-colors">
                    <i className={`${feat.icon} text-xl text-secondary-600 group-hover:text-background-50 transition-colors`}></i>
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 group-hover:text-background-50 transition-colors font-heading whitespace-nowrap">
                    {feat.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="text-center mb-10">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
                <span className="text-xs font-medium text-accent-600 whitespace-nowrap">读者口碑</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading leading-tight">
                漫画爱好者的真实评价
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                数百万读者的共同选择，听听他们怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, idx) => (
                <div
                  key={t.id}
                  className={`bg-background-50 rounded-lg p-5 ${idx === 5 ? 'opacity-50' : ''}`}
                >
                  <div className="flex gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                      ></i>
                    ))}
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-2">{t.title}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-4">{t.comment}</p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-800">{t.name}</p>
                      <p className="text-[10px] text-foreground-400">{t.time}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20" id="contact">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block px-4 py-1.5 border border-foreground-300 text-foreground-700 text-xs font-medium rounded-full whitespace-nowrap">
                  联系方式
                </span>
                <h2 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
                  与我们取得联系
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-4">
                    <i className="ri-phone-line text-lg text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">电话</h3>
                  <p className="text-sm text-foreground-600 whitespace-nowrap">{siteInfo.phone}</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-4">
                    <i className="ri-mail-line text-lg text-accent-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">邮箱</h3>
                  <p className="text-sm text-foreground-600">{siteInfo.email}</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-4">
                    <i className="ri-map-pin-line text-lg text-secondary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">地址</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{siteInfo.address}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-10">
                常见问题
              </h2>
              <div className="space-y-4">
                {faqSchema.mainEntity.map((faq, idx) => (
                  <details key={idx} className="bg-background-50 rounded-lg p-5 group cursor-pointer">
                    <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                      {faq.name}
                      <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                      {faq.acceptedAnswer.text}
                    </p>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}